module.exports = "<app-coursessilde></app-coursessilde>\r\n<app-view-all-courses></app-view-all-courses>\r\n<app-cta></app-cta>\r\n"